import { action } from 'satcheljs';

const onFlightsApiResponseProcessed = action(
    'ON_FLIGHTS_API_RESPONSE_PROCESSED',
    (dogfoodFlights: string[], microsoftFlights: string[], wwFlights: string[]) => ({
        dogfoodFlights,
        microsoftFlights,
        wwFlights,
    })
);

export default onFlightsApiResponseProcessed;
